import Icon from '@ant-design/icons';
import { Button, Modal } from 'antd';
import classNames from 'classnames';
import { useMemo } from 'react';

import HomepageEditPage from '@/components/Homepage/HomepageEditPage';
import RightSvg from '@/components/Icon/svgs/right.svg';
import useAppBridge from '@/hooks/useAppBridge';
import { useTranslation } from '@/i18n/client';
import { useHomePageStore } from '@/store/useHomepageStore';

import styles from './index.less';

export type GuideType = 'name' | 'bio' | 'cover';

interface IProps {
  open: boolean;
  handleClose: () => void;
  type?: 'edit' | 'init' | 'briefInit' | 'briefEdit' | 'validationEdit';
  handleNextStep?: () => void;
  guideType?: GuideType;
}

const HomepageEditPageModal = (props: IProps) => {
  const { open, handleClose, type = 'edit', handleNextStep, guideType } = props;

  const homePage = useHomePageStore((state) => state.homePage);

  const canNext = useMemo(() => {
    return !!homePage?.cover || !!homePage?.video;
  }, [homePage]);

  const { t } = useTranslation();

  const { SAFE_AREA_TOP } = useAppBridge();

  return (
    <Modal
      className={styles.modal}
      closable={false}
      destroyOnClose
      footer={null}
      mask={false}
      onCancel={() => {
        handleClose();
      }}
      open={open}
    >
      <div
        className="absolute w-full h-[60px] top-0 left-0 z-[10] px-4 flex items-center"
        style={
          SAFE_AREA_TOP
            ? {
                top: `${SAFE_AREA_TOP}vw`
              }
            : undefined
        }
      >
        {type === 'briefInit' ? null : (
          <div
            className={
              'w-9 h-9 bg-[rgba(254,253,255,0.6)] rounded-[18px] p-1 cursor-pointer hover:bg-[rgba(254,253,255,0.8)] transition-all duration-200 z-[10]'
            }
            onClick={handleClose}
          >
            <Icon className="text-[28px] text-primary-black" component={RightSvg} rotate={180} />
          </div>
        )}
        {handleNextStep && type === 'init' && (
          <Button
            className={classNames(styles.confirmButton, { [styles.canClick]: canNext }, 'ml-auto')}
            disabled={!canNext}
            onClick={handleNextStep}
          >
            <div>{t('common.next')}</div>
            <Icon component={RightSvg} />
          </Button>
        )}
      </div>
      <HomepageEditPage
        guideType={guideType}
        handleClose={handleClose}
        handleNextStep={handleNextStep}
        type={type}
      />
    </Modal>
  );
};

export default HomepageEditPageModal;
